<template>
	<div class="bottom_sheet" :style="{
		height: `${currentHeight}px`,
		transition: isDragging ? 'none' : 'height 0.3s ease'
	}">
		<div class="bottom_sheet_header" @mousedown="startDrag" @touchstart="startDrag">
			<div />
		</div>
		<div class="bottom_sheet_content">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			startY: 0,
			currentHeight: window.innerHeight * 0.8,
			minHeight: window.innerHeight * 0.25,
			maxHeight: window.innerHeight * 0.8,
			isDragging: false
		}
	},
	methods: {
		handledrag() {
			// 라벨 클릭시 창 최소화
			this.currentHeight = 210
		},

		startDrag(event) {
			event.preventDefault(); // pull to refresh로 인하여 기본동작방지 추가.
			this.isDragging = true;
			this.startY = event.clientY || event.touches[0].clientY
			window.addEventListener('mousemove', this.onDrag)
			window.addEventListener('mouseup', this.stopDrag)
			window.addEventListener('touchmove', this.onDrag, { passive: false }) // 기본 동작 방지
			window.addEventListener('touchend', this.stopDrag)
		},
		onDrag(event) {
			event.preventDefault(); // pull to refresh로 인하여 기본동작방지 추가.
			if (!this.isDragging) return

			const clientY = event.clientY || event.touches[0].clientY;
			const diffY = this.startY - clientY;
			const newHeight = this.currentHeight + diffY;

			this.currentHeight = Math.max(
				this.minHeight,
				Math.min(this.maxHeight, newHeight)
			)
			this.startY = clientY
		},
		stopDrag() {
			this.isDragging = false
			window.removeEventListener('mousemove', this.onDrag)
			window.removeEventListener('mouseup', this.stopDrag)
			window.removeEventListener('touchmove', this.onDrag, { passive: false })
			window.removeEventListener('touchend', this.stopDrag)
		}
	}
}
</script>

<style scoped>
.bottom_sheet {
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	max-width: 768px;
	background-color: var(--gray-scale-12);
	overflow: hidden;
	box-shadow: rgba(0, 0, 0, 0.3) 0px -2px 16px;
	border-top-left-radius: 16px;
	border-top-right-radius: 16px;
}

.bottom_sheet>.bottom_sheet_header {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 8px 0;
}

.bottom_sheet>.bottom_sheet_header>div {
	width: 36px;
	height: 4px;
	background-color: var(--gray-scale-7);
	border-radius: 100px;
}

.bottom_sheet>.bottom_sheet_content {
	height: 100%;
	overflow-y: scroll;
	padding-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/ai/AiBottomSheet.vue